import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import styles from './AdminPage.module.css';
import { axiosCms } from 'Axios.js';
import { parseAdmins } from 'store/reducers/admins';
import WithError from 'HOC/Error/WithError';
import { createAdmin, fetchAdmins, updateAdmin, deleteAdmin } from 'store/actions/index';
// PageContainer: CSS Grid area <title> and <main>
import * as Page from 'HOC/Layout/PageContainer';
import AdminTable from 'components/Admin/SuperAdmin/Table/AdminTable';
import CreateAdminModal from 'components/Admin/SuperAdmin/CreateAdmin/CreateAdminModal';

const { Container, Title } = Page;

class AdminPage extends Component {
  state = {
    showCreateModal: false,
  };

  componentDidMount() {
    const { fetchAdmins } = this.props;
    fetchAdmins();
  }

  toggleCreateModalHandler = () => {
    this.setState(prevState => ({ ...prevState, showCreateModal: !this.state.showCreateModal }));
  };

  deleteAdminHandler = id => {
    const { deleteAdmin, fetchAdmins } = this.props;

    deleteAdmin(id)
      .then(fetchAdmins)
      .then(() => {
        message.success('Delete successful', 1);
      })
      .catch(console.error);
  };

  updateAdminHandler = (data, id) => {
    const { updateAdmin } = this.props;

    return updateAdmin(data, id);
  };

  onSubmitHandler = e => {
    e.preventDefault();
    const { createAdmin, fetchAdmins } = this.props;
    const { validateFields } = this.form;
    validateFields((err, values) => {
      if (!err) {
        createAdmin(values)
          .then(fetchAdmins)
          .then(() => {
            message.success('Create successful', 1);
          })
          .catch(console.error);
        this.toggleCreateModalHandler();
        setTimeout(() => {
          this.form.resetFields();
        }, 100);
      } else {
        return;
      }
    });
  };

  saveFormRef = form => {
    this.form = form;
  };

  renderContainer = () => {
    const { parsedAdmins, isLoading } = this.props;
    const { showCreateModal } = this.state;
    return (
      <Container type="2x3">
        <Title title="Admins" button={true} onClick={this.toggleCreateModalHandler} />
        <div className={styles.Main}>
          <AdminTable
            admins={parsedAdmins}
            isLoading={isLoading}
            deleteAdmin={this.deleteAdminHandler}
            updateAdmin={this.updateAdminHandler}
          />
          <CreateAdminModal
            ref={this.saveFormRef}
            visible={showCreateModal}
            onCancel={this.toggleCreateModalHandler}
            onOk={this.onSubmitHandler}
            loading={isLoading}
          />
        </div>
      </Container>
    );
  };

  render() {
    return this.renderContainer();
  }
}

const mapStateToProps = state => {
  const { admins } = state.admin;
  const parsedAdmins = parseAdmins(admins);
  const isLoading = state.admin.loading || state.auth.loading;
  return {
    parsedAdmins,
    isLoading,
  };
};

const mapDispatchToProps = { createAdmin, fetchAdmins, deleteAdmin, updateAdmin };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithError(AdminPage, axiosCms));



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminPage.js